import Phaser from "phaser";

type SoundEvent = "throw" | "catch" | "bigCatch" | "powerup" | "gameOver";

export class AudioManager {
    private readonly scene: Phaser.Scene;

    constructor(scene: Phaser.Scene) {
        this.scene = scene;
    }

    play(event: SoundEvent): void {
        const soundManager = this.scene.sound as Phaser.Sound.NoAudioSoundManager | Phaser.Sound.HTML5AudioSoundManager | Phaser.Sound.WebAudioSoundManager;
        const context = "context" in soundManager ? soundManager.context : undefined;
        if (!context) {
            return;
        }

        const now = context.currentTime;
        const [frequency, duration, type] = this.resolveTone(event);
        const osc = context.createOscillator();
        const gain = context.createGain();
        osc.type = type;
        osc.frequency.setValueAtTime(frequency, now);
        gain.gain.setValueAtTime(0.001, now);
        gain.gain.exponentialRampToValueAtTime(0.08, now + 0.01);
        gain.gain.exponentialRampToValueAtTime(0.001, now + duration);
        osc.connect(gain);
        gain.connect(context.destination);
        osc.start(now);
        osc.stop(now + duration + 0.01);
    }

    private resolveTone(event: SoundEvent): [number, number, OscillatorType] {
        switch (event) {
            case "throw":
                return [520, 0.09, "triangle"];
            case "catch":
                return [700, 0.12, "sine"];
            case "bigCatch":
                return [420, 0.2, "square"];
            case "powerup":
                return [880, 0.16, "triangle"];
            case "gameOver":
                return [180, 0.45, "sawtooth"];
            default:
                return [600, 0.1, "sine"];
        }
    }
}
